module.exports = __webpack_public_path__ + "media/images/bg/right_bg-8476e936e745c74ee4771739ad487fed.jpg";